export default __webpack_public_path__ + "static/media/wheel-button.37d2bd8c.gif";